/**
 * ts implementation of Kms_Type_UserProfile_UserRegistrationType
 */
export enum KmsRegistrationType {
    virtualAttendanceRequest = "virtualAttendanceRequest",
    inPersonAttendanceRequest = "inPersonAttendanceRequest",
    both = "both",
}
